// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AJz385bOEK0EzcBfmfg3{flex-direction:column;height:100%;padding:16px 0 32px;display:flex}.AJz385bOEK0EzcBfmfg3 .RBzHamNmgaMYvNMELV5W{padding:12px 24px 24px}.AJz385bOEK0EzcBfmfg3 .SPXsXsEAzd8Vd6o6Rpmk,.AJz385bOEK0EzcBfmfg3 .tR6a5JCZEt1wY9D9p6wA{padding:0 24px}.AJz385bOEK0EzcBfmfg3 .wa0pD15QLIw2AFTW_hVo{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `AJz385bOEK0EzcBfmfg3`,
	"status": `RBzHamNmgaMYvNMELV5W`,
	"title": `SPXsXsEAzd8Vd6o6Rpmk`,
	"tabs": `tR6a5JCZEt1wY9D9p6wA`,
	"content": `wa0pD15QLIw2AFTW_hVo`
};
export default ___CSS_LOADER_EXPORT___;
